import { Box, Typography, Button, Stack } from "@mui/material";
import { Link } from "react-router-dom";

const WHATSAPP_NUMBER = "919532119007"; // 👈 replace with real number

const NoData = ({
  title = "No data found",
  description = "We couldn’t find what you’re looking for.",
  showHome = true,
  showContact = false,
  minHeight = "50vh",
}) => {
  return (
    <Box
      sx={{
        minHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          maxWidth: 420,
          p: { xs: 3, md: 4 },
          borderRadius: 3,
          backgroundColor: "#fff",
          boxShadow: "0 16px 50px rgba(13,59,102,0.15)",
        }}
      >
        {/* Icon / Emoji */}
        <Typography sx={{ fontSize: 48, mb: 1 }}>😕</Typography>

        {/* Title */}
        <Typography
          sx={{
            fontSize: { xs: "1.3rem", md: "1.5rem" },
            fontWeight: 800,
            color: "var(--text-heading)",
            mb: 1,
          }}
        >
          {title}
        </Typography>

        {/* Description */}
        <Typography
          sx={{
            fontSize: "0.95rem",
            color: "var(--text-secondary)",
            lineHeight: 1.6,
            mb: 3,
          }}
        >
          {description}
        </Typography>

        {/* Actions */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1.5}
          justifyContent="center"
        >
          {showHome && (
            <Button
              component={Link}
              to="/"
              variant="contained"
              sx={{
                px: 3,
                backgroundColor: "var(--color-neon)",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "var(--color-neon)",
                  opacity: 0.9,
                },
              }}
            >
              🏠 Go Home
            </Button>
          )}

          {showContact && (
            <Button
              component="a"
              href={`https://wa.me/${WHATSAPP_NUMBER}`}
              target="_blank"
              variant="outlined"
              sx={{
                px: 3,
                borderColor: "var(--color-neon)",
                color: "var(--color-neon)",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "rgba(13,59,102,0.05)",
                },
              }}
            >
              💬 Contact Us
            </Button>
          )}
        </Stack>
      </Box>
    </Box>
  );
};

export default NoData;
